import ImageError from 'assets/png/error/hav_error.png'
import ImageLogo from 'assets/png/error/hav_logo.png'
import { Page, TextButton, Typography } from 'components'

import {
  ErrorImageStyled,
  LogoImageStyled,
  WrapperContentStyled,
  WrapperContentTextStyled,
  WrapperSubTitlePageStyled,
  WrapperTitlePageStyled,
} from './styles'

function Error() {
  return (
    <Page hasHeader={false}>
      <WrapperContentStyled>
        <LogoImageStyled alt="Logo Havaianas" src={ImageLogo} />
        <WrapperTitlePageStyled>
          <Typography design="hav-default-01-text" variant="h1">
            Ops! Página não encontrada
          </Typography>
        </WrapperTitlePageStyled>
        <ErrorImageStyled alt="Erro ao carregar a página" src={ImageError} />
        <WrapperSubTitlePageStyled>
          <Typography design="hav-default-01-text" variant="h2">
            O que pode ter acontecido?
          </Typography>
        </WrapperSubTitlePageStyled>
        <WrapperContentTextStyled>
          O conteúdo não está mais disponível ou você digitou o endereço errado.
        </WrapperContentTextStyled>
        <WrapperContentTextStyled>
          <TextButton url="/">Clique aqui</TextButton> e volte para a Página Inicial.
        </WrapperContentTextStyled>
      </WrapperContentStyled>
    </Page>
  )
}

export default Error
